module.exports = __webpack_public_path__ + "img/chevron-down-white.da13841e.svg";